import { Skeleton } from "@/shared/ui";

interface Props {
  variant?: "full" | "tableOnly";
}

export default function ContractorPayrollPageSkeleton({ variant = "full" }: Props) {
  if (variant === "tableOnly") {
    return (
      <div className="flex flex-col">
        <div className="grid grid-cols-7 gap-4 pb-3 border-b surface-base-stroke">
          {Array.from({ length: 7 }).map(function renderHeadSkeleton(_, i) {
            return <Skeleton key={i} height={20} />;
          })}
        </div>
        {Array.from({ length: 6 }).map(function renderRowSkeleton(_, rowIndex) {
          return (
            <div key={rowIndex} className="grid grid-cols-7 gap-4 py-3 border-b surface-base-stroke">
              {Array.from({ length: 7 }).map(function renderCellSkeleton(_, colIndex) {
                return <Skeleton key={colIndex} height={20} />;
              })}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="radius-3xl surface-base-fill p-7">
        <div className="flex items-center gap-2 mb-7">
          <Skeleton width={192} height={32} borderRadius={8} />
          <Skeleton width={160} height={32} borderRadius={8} />
          <Skeleton width={160} height={32} borderRadius={8} />
        </div>

        <div className="flex flex-col">
          <div className="grid grid-cols-7 gap-4 pb-3 border-b surface-base-stroke">
            {Array.from({ length: 7 }).map(function renderHeadSkeleton(_, i) {
              return <Skeleton key={i} height={20} />;
            })}
          </div>
          {Array.from({ length: 6 }).map(function renderRowSkeleton(_, rowIndex) {
            return (
              <div key={rowIndex} className="grid grid-cols-7 gap-4 py-3 border-b surface-base-stroke">
                {Array.from({ length: 7 }).map(function renderCellSkeleton(_, colIndex) {
                  return <Skeleton key={colIndex} height={20} />;
                })}
              </div>
            );
          })}
        </div>

        <div className="flex items-center justify-between mt-4">
          <Skeleton width={200} height={20} />
          <div className="flex items-center gap-2">
            {Array.from({ length: 4 }).map(function renderPaginationSkeleton(_, i) {
              return <Skeleton key={i} width={32} height={32} borderRadius={8} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
